import gql from "graphql-tag";

export const getAllQuery = gql`
  query GetAllQuery {
    programs {
      id
      name
    }
  }
`;